export default (installment, price) => ({
  text: `${installment}x de R$ ${price.toLocaleString('pt-br', { minimumFractionDigits: 2 })}`,
  value: installment
})



// WEBPACK FOOTER //
// ./src/Checkout/createInstallment.js